import React, { Component } from 'react';
import styled from 'styled-components';
import Menu from '../Menu/Menu';
import Sidemenu from '../Sidemenu/Sidemenu';
import Card, { Ticket } from '../Card/Card';
import CompanyLogo from './logo.png';
const axios = require('axios').default;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Container = styled.div`
display: flex;
margin: 0 auto;
max-width: 757px;
margin: 0 auto;`;


const Logo = styled.img`
margin: 50px 0px;`;



const Main = styled.main``;

interface AppState {
  [index: string]: any;
  filter: {
    [index: string]: any;
  };
  data: Ticket[];
  sortedData: Ticket[];
}

interface searchId {
  data: {
    searchId: string;
  }
}

interface Responce {
  data: {
    stop: boolean
  }
}

export default class Filter extends Component {
  state: AppState = {
    filterOn: false,
    cheap: true,
    fast: false,
    filter: {
      all: {
        checked: false,
        value: 0
      },
      zero: {
        checked: false,
        value: 0,
      },
      one: {
        checked: false,
        value: 1,
      },
      two: {
        checked: false,
        value: 2,
      },
      three: {
        checked: false,
        value: 3,
      },
    },
    data: [],
    sortedData: [],
  }

  componentDidMount() {
    if(!this.state.id) {
      axios.get('https://front-test.beta.aviasales.ru/search').then((responce: searchId) => {
        this.setState({
          ...this.state,
          id: responce.data.searchId
        })
      this.getTickets(responce.data.searchId);
      });
    }
  }


  getTickets = (id: string): void => {
        let newData:any = [];

        axios.get(`https://front-test.beta.aviasales.ru/tickets?searchId=${id}`).then((responce: any) => {
          if(responce.status === 200) {
            this.getTickets(id);
          }
          newData = [...this.state.data, ...responce.data.tickets];
            const newState = {
              ...this.state,
              data: newData
            }
            this.setState(newState);
        }).catch((er: Error) => {
          console.log('an Error have occured');
        }) ;
    }

  sortByStops = (data: AppState) => {
    const tickets = data.data;
    let newData: Ticket[] = [];

    const { all, ...rules } = data.filter;
    const { filter } = data;

    if(all.checked) {
      newData = [...tickets];
    } else {
      let terms: number[] = [];
      Object.entries(rules).forEach((rule, index) => {
        if(rule[1].checked) {
          terms.push(rule[1].value);
        }
      });


      newData = tickets.filter(ticket => {
        const len = ticket.segments[0].stops.length + ticket.segments[1].stops.length;

        return terms.includes(len);
      })
    }  

    data.cheap ?  this.sortByPrice(newData, true) : this.sortByTime(newData);

    const sortedData = {
      ...data,
      sortedData: [...newData]
    }

    return sortedData;
  }

  sortByPriceInAscendingOrder = (a:Ticket, b:Ticket) => {
    return a.price - b.price;
  }
  
  sortByPriceInDescendingOrder = (a:Ticket, b:Ticket) => {
    return b.price - a.price;
  }

  sortByPrice = (tickets: Ticket[], descending: boolean) => {
    return descending ? tickets.sort(this.sortByPriceInAscendingOrder) : tickets.sort(this.sortByPriceInDescendingOrder);
  }

  sortByTime = (tickets: Ticket[]) => {
    return tickets.sort((a, b) => {
      const timeA = a.segments[0].duration + a.segments[1].duration;
      const timeB = b.segments[0].duration + b.segments[1].duration;
      return timeA - timeB;
    });
  }

  onSidemenuChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const key = e.target.dataset.key;
    const oldFilterState = {...this.state.filter};
    let newCheckboxState;
    if(typeof key === 'string') newCheckboxState = !oldFilterState[key].checked;

    const newFilterState = {
      ...oldFilterState,
      [key as string]: {
        ...this.state.filter[key as string],
            checked: newCheckboxState 
      }
    }

    const filterIsOn = Object.values(newFilterState).reduce((previousValue, currentValue) => {
      const checked = Number(currentValue.checked);
      return previousValue + checked;      
    }, 0);

    let newState = {
        ...this.state,
        filterOn: Boolean(filterIsOn),
        filter: {
          ...newFilterState,
        }
      }
      this.onSort(newState);
  }

  onSort = (data: AppState) => {

    const sorted = this.sortByStops(data);

    this.setState(sorted);
  }

  onMenuChangeHandler = (e: React.ChangeEvent<HTMLButtonElement>) => {
    const active = e.target.dataset.active;
    const inActive = e.target.dataset.inActive;
    if(e.target.dataset.checked === 'false') {
  
      e.target.setAttribute('data-checked', 'true');
      const sibling = document.getElementById(`${inActive}`);
   
      sibling ? sibling.setAttribute('data-checked', 'false') : null;

      const newState = {
        ...this.state,
        [active as string]: !this.state[active as string],
        [inActive as string]: !this.state[inActive as string],
      }

      this.onSort(newState)
    }
  }


  render() {
    let Cards = [];
    if( this.state.data.length > 0 && this.state.filterOn) {
      for(let i = 0; i < 5; i = i + 1) {
        let ticket = this.state.sortedData[i];
        Cards.push(<Card carrier={ticket.carrier} price={ticket.price} segments={ticket.segments}/>)
      }
    } else {
      Cards.push(<p> Нет билетов соотвествующих вашим настройкам </p>)
    }


    return (
      <Wrapper>
        <Logo src={CompanyLogo}/>
      <Container>


        <Sidemenu change={this.onSidemenuChangeHandler} options={this.state.filter}/>
        <Main>
          <Menu change={this.onMenuChangeHandler} cheap={this.state.cheap} fast={this.state.fast}></Menu>
          {
            Cards 
          }
        </Main>
      </Container>
      </Wrapper>
    )
  }
};